export const API = {
    assetUrl: 'https://admin.tierarztpraxis-enge.ch/',
    baseUrl: 'https://admin.tierarztpraxis-enge.ch/vet-cockpit/',
    key: 'b15c1dcb53e7dc77e6844663e20046',
    form: 'Weinbestellung',
    basePage: 'de'
}
